import React from 'react';
import LinkArrow from '../../global/LinkArrow';
import Lottie from 'react-lottie';

interface FeatureItem {
  title: string;
  description: string;
  link: {
    title: string;
    href: string;
  };
  image?: string;
  lottie?: any;
}

interface FeaturesSectionProps {
  title: string;
  items: readonly FeatureItem[];
}

const getLottieOptions = (lottieData: any) => ({
  loop: true,
  autoplay: true,
  animationData: lottieData,
});

export const FeaturesSection = ({ title, items }: FeaturesSectionProps) => {
  return (
    <section className="py-24">
      <h2 className="text-2xl lg:text-5xl font-medium mb-16 max-w-[40rem] text-center mx-auto">
        {title}
      </h2>
      <div className="flex flex-col border-t border-[#DBDBDB]">
        {items.map((item, index) => (
          <div key={index} className="border-b border-[#DBDBDB]">
            <div className="grid grid-cols-12 items-start">
              <div
                className={`col-span-12 flex flex-col justify-center ${
                  index % 2 === 1 ? 'lg:order-2 lg:col-span-7' : 'lg:col-span-6'
                } border-b lg:border-b-0 border-[#DBDBDB] pt-6 relative flex-1 `}
              >
                <div className="py-8 px-2 sm:px-24">
                  <h3 className="text-lg md:text-2xl font-medium mb-4">
                    {item.title}
                  </h3>
                  <p
                    className=""
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </div>
                <div className="border-t border-[#DBDBDB] py-6 px-24">
                  <LinkArrow to={item.link.href} color="orange" size="md">
                    {item.link.title}
                  </LinkArrow>
                </div>
              </div>
              <div
                className={`relative col-span-12 h-full flex-1 flex items-start rounded-lg overflow-hidden ${
                  index % 2 === 1
                    ? 'lg:order-1 lg:justify-end lg:col-span-5 lg:border-r '
                    : 'items-start lg:col-span-6 lg:border-l'
                }`}
              >
                <div className="px-0 sm:px-24 lg:px-0 h-full bg-white z-10 max-w-full flex flex-col justify-end">
                  {item.lottie ? (
                    <div className="object-contain h-full max-h-64">
                      <Lottie options={getLottieOptions(item.lottie)} />
                    </div>
                  ) : item.image ? (
                    <img
                      src={item.image}
                      alt={item.title}
                      className="object-contain h-full max-h-64"
                    />
                  ) : (
                    <div className="w-full h-auto bg-gray-100" />
                  )}
                </div>
                <div className="absolute bottom-0 left-0 top-0 right-0 w-full overflow-hidden">
                  <div className="bg-[repeating-linear-gradient(-45deg,transparent,transparent_3px,#EEEEEE_0,#EEEEEE_4px)] w-full h-full" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
